export const Logo = ({ className = "", mark = "" }) => {
  return (
    <div
      className={`flex items-center gap-[0.12em] font-display font-extrabold uppercase leading-none select-none ${className}`}
      data-testid="hor-logo"
    >
      <span className="text-foreground">H</span>
      <span className="relative inline-flex items-center justify-center w-[0.78em] h-[0.78em] mx-[0.02em]">
        <span className="absolute inset-0 rounded-full border-[0.14em] border-acid" />
        <span className="absolute w-[0.22em] h-[0.22em] rounded-full bg-acid" />
      </span>
      <span className="text-foreground">R</span>
      {mark && <span className="ml-2 text-acid">{mark}</span>}
    </div>
  );
};
